import React, { useEffect, useRef, useState } from 'react';
import './ChatScroll.css';
import 'intersection-observer';
import { useDispatch, useSelector } from 'react-redux';
import { getUserId } from '../../store/User/UserSelectors';
import {BUSY_MESSAGE, fetchSuggestions,} from '../../store/Suggestions/SuggestionsActions';
import {
  loadMessages,
  setIntervalCounter,
  setScrollToBottom,
} from '../../store/Messages/MessagesActions';
import {
  getIntervalCounter,
  getMessages,
  getScrollToBottom,
} from '../../store/Messages/MessagesSelectors';
import HomeView from '../HomeView/HomeView';
import ChatView from '../ChatView/ChatView';
import DevInternalSelector from '../DevInternalSelector/DevInternalSelector';
import { setTenantConfig } from '../../store/Config/ConfigActions';
import { getTenantConfig } from '../../store/Config/configSelectors';

const configFileName = process.env.REACT_APP_CONFIG_FILE;
const config = require(`../../TenantConfig/${configFileName}`);
const IS_INTERNAL_DEV = configFileName === 'config.ema-internal-dev.js';

const ChatScroll = () => {
  const dispatch = useDispatch();

  const messagesEndRef = useRef(null);
  const [home, setHome] = useState(true);

  const userId = useSelector(getUserId);
  const messages = useSelector(getMessages);
  const intervalCounter = useSelector(getIntervalCounter);
  const scrollToBottom = useSelector(getScrollToBottom);
  const tenantConfig = useSelector(getTenantConfig);

  useEffect(() => {
    if (config) {
      dispatch(setTenantConfig(config));
    }
  }, [config]);

  useEffect(() => {
    // Set the document title based on the config
    document.title = tenantConfig.pageTitle || 'Ema';
  }, [tenantConfig.pageTitle]);

  useEffect(() => {
    // If tenantConfig includes an initialPrompt, ensure ChatView is shown immediately.
    if (tenantConfig && tenantConfig.initialPrompt) {
      setHome(false);
    }
  }, [tenantConfig]);

  useEffect(() => {
    if (userId) {
      dispatch(loadMessages(userId));
      setHome(false);
    }
  }, [userId]);

  useEffect(() => {
    if (tenantConfig) {
      dispatch(fetchSuggestions()); // Fetch suggestions on mount
    }
  }, [tenantConfig]);

  useEffect(() => {
    setTimeout(() => {
      if (intervalCounter > 0) {
        if (
            userId &&
            (
                messages.length === 0 ||
                // If there are messages, load if the last one is not 'ema',
                // or if it is an 'ema' but equals the busyMessage.
                (messages.length > 0 &&
                    (messages[messages.length - 1].type !== 'ema' ||
                        (BUSY_MESSAGE && messages[messages.length - 1].message === BUSY_MESSAGE)))
            )
        ) {
          dispatch(loadMessages(userId));
        }
        dispatch(setIntervalCounter(intervalCounter - 1));
      }
    }, 3000);
  }, [messages, userId, intervalCounter]);


  const triggerScrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    dispatch(setScrollToBottom(false));
  };

  const generateTranscript = () => {
    let bufferString = '';
    messages.forEach(message => {
      bufferString += (message.type === 'ema' ? 'Ema: ' : 'You: ') + message.message + '\n\n';
    });
    return bufferString;
  };

  const downloadTranscript = () => {
    const transcript = generateTranscript();
    const element = document.createElement('a');
    const file = new Blob([transcript], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = 'myChat.txt';
    document.body.appendChild(element); // Required to work in FireFox
    element.click();
  };

  useEffect(() => {
    if (scrollToBottom) {
      triggerScrollToBottom();
    }
  }, [scrollToBottom]);

  return (
      <div className="Outer-Wrapper">
        {IS_INTERNAL_DEV && <DevInternalSelector setHome={setHome} />}
        {home ? <HomeView setHome={setHome} /> : <ChatView setHome={setHome} />}
      </div>
  );
};

export default ChatScroll;